import { TSingleRadius } from '~ui/styleGuide/radiuses'
import { TSingleSpace } from '~ui/styleGuide/spaces'

// delay the error state to be displayed to the end-user in milliseconds.
// Correct the error input will remove the error instantly and delay will not be applied.
// https://react-hook-form.com/api/useform
export const VALIDATION_ERROR_DELAY = 300 //ms

// unified radiuses across FormScreen inputs & buttons
export const FORM_INPUT_RADIUS: TSingleRadius = `small`
// unified space between multiple elements (inputs/buttons) in a row on FormScreen
export const FORM_HORIZONTAL_SPACE: TSingleSpace = `extraSmall`
